const IMA_SCRIPT_ID = 'ima-sdk';

export default class ImaScriptLoader {
  load(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.getElementById(IMA_SCRIPT_ID)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = '//imasdk.googleapis.com/js/sdkloader/ima3.js';
      script.async = true;
      script.type = 'text/javascript';
      script.id = IMA_SCRIPT_ID;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.body.appendChild(script);
    });
  }

  unload(): void {
    const imaScript = document.getElementById(IMA_SCRIPT_ID);
    if (imaScript) {
      document.body.removeChild(imaScript);
    }
  }
}
